import React from 'react';
import slider1 from '../assets/images/IMG_2655.JPG';
import slider2 from '../assets/images/IMG_5050.JPG';
import slider3 from '../assets/images/slider3.JPG';

function Slider(){
    return(
        <div id="slider">
            <figure>
                <img src={slider3} alt="slider-3"/>
                <img src={slider2} alt="slider-2"/>
                <img src={slider1} alt="slider-1"/>
                <img src={slider3} alt="slider-4"/>
            </figure>
            <div className="dark">
                <h1>Welcome To Official Website of IRINA</h1>
                <span>Ikatan Remaja Islam Nurul Falah</span>
            </div>
        </div>
    )
}

export default Slider;